import { AxiosResponse } from 'axios';
import { saveAs } from 'file-saver';
import {
  all,
  AllEffect,
  call,
  CallEffect,
  delay,
  ForkEffect,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { Wishlist } from 'b2b-apps/shop/myAccount/wishlists/api/Wishlist';
import {
  wishlistExportFulfilled,
  wishlistExportRejected,
} from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistExport/actionCreators';
import { WISHLIST_EXPORT } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistExport/actionTypes';
import { WishlistExportAction } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistExport/types';

const GENERATE_CSV_DELAY = 1000;

function* exportWishlistCSVSaga(
  wishlistId: string,
  fileName: string,
): Generator<CallEffect, AxiosResponse, AxiosResponse> {
  const response = yield call(requestApiSaga, Wishlist.generateCSV(wishlistId));
  saveAs(
    new Blob([response.data], {
      type: 'text/csv;charset=utf-8;',
    }),
    `${fileName}.csv`,
  );
  return response;
}

function* exportWishlistSaga(
  action: WishlistExportAction,
): Generator<CallEffect | PutEffect, any, any> {
  const { wishlistId, fileName } = action.payload;

  try {
    yield call(exportWishlistCSVSaga, wishlistId, fileName);
    yield delay(GENERATE_CSV_DELAY);
    yield put(wishlistExportFulfilled());
  } catch (error) {
    yield put(reportError(action.type, error, action.payload));
    yield put(wishlistExportRejected(parseError(error)));
  }
}

function* wishlistExportSaga(): Generator<AllEffect<ForkEffect>, any, void> {
  yield all(
    [
      takeEvery(WISHLIST_EXPORT, exportWishlistSaga),
    ],
  );
}

export { wishlistExportSaga };
